export default (errors) => {
  if (errors === null) {
    return false;
  }

  if (Array.isArray(errors)) {
    return errors.length > 0;
  }

  return errors;
};
